import { Version } from '@grammarly/version'
import { BUILD_TAG, SERVICE_NAME } from '../../../constants'
import { Cookie, getCookie } from '../../utils/cookies'

export const clientName = SERVICE_NAME
export const clientNameFunnel = 'funnel'
export const clientVersion = Version.parse(BUILD_TAG)
export const getCsrfToken = () => getCookie(Cookie.CsrfToken) as string
